import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { navigate } from "gatsby"
import SiteLogo from "../SiteLogo"
import DarkModeToggle from "../DarkModeToggle"
import TextField from "../TextField"
import {SocialIcon} from "react-social-icons";

const SideMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  grid-template-columns: 1fr;
  grid-gap: 30px;
  padding-top: 25px;
  min-width: 300px;
  max-width: 300px;
  position: fixed;
  height: 100%;
  padding-bottom: 100px;
`
const TopWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 30px;
  justify-items: center;
`

const BottomWrapper = styled.div`
  padding-top: 35px;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  flex-direction: column-reverse;
  bottom: 0;
  align-items: center;
`

const IconsWrapper = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 20px;
`

const SideMenu = ({ location, rootPath, isSearch }) => {
  const [searchQuery, setSearchQuery] = useState("")

  useEffect(() => {
    setSearchQuery(new URLSearchParams(location.search).get("keywords") || "")
  }, [location.search, searchQuery])

  return (
    <SideMenuWrapper>
      <TopWrapper>
        <SiteLogo />
        <IconsWrapper>
          <SocialIcon
              url="https://www.youtube.com/channel/UC91waLGpNuo9Q0SjvtP9RVA"
              style={{ height: 32, width: 32 }}
              bgColor={"var(--logo)"}
          />
          <SocialIcon
              style={{ height: 32, width: 32 }}
              url="https://twitter.com/willmakestv"
              bgColor={"var(--logo)"}
          />
          <SocialIcon
              style={{ height: 32, width: 32 }}
              url="https://www.twitch.tv/willmakestv"
              bgColor={"var(--logo)"}
          />
          <SocialIcon
              style={{ height: 32, width: 32 }}
              url="https://github.com/WillMakesTV"
              bgColor={"var(--logo)"}
          />
        </IconsWrapper>

        <DarkModeToggle />

      </TopWrapper>
      <BottomWrapper>
        <div
          css={`
            margin: 0px 60px 0px 60px;
          `}
        >
          <TextField
            autoFocus={isSearch} // eslint-disable-line
            search={true}
            type="search"
            id="search-input"
            name="keywords"
            aria-controls="search-results-count"
            handleChange={value =>
              navigate(`/search?keywords=${encodeURIComponent(value)}`)
            }
            value={searchQuery}
            placeholder={`Search`}
          />
        </div>
      </BottomWrapper>
    </SideMenuWrapper>
  )
}

export default SideMenu
